import { Helmet } from 'react-helmet';
import CreateConsultFirstStepForm from './CreateConsultFirstStepForm/CreateConsultFirstStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Étape 1 - Déposer une consultation</title>
      </Helmet>
      <div className="createConsult__steps">
        <div className="createConsult__stepBox">
          <label className="createConsult__stepBoxLabel">Informations de base</label>
        </div>
      </div>
      <div className="createConsult__container">
        <CreateConsultFirstStepForm />
      </div>
    </>
  );
};
